module.exports = __webpack_public_path__ + "img/internet9.c637641d.png";